import React from 'react';

export const StorageTableBody = ({children}: {children: React.ReactNode}) => {
  return <div className="w-full">{children}</div>;
};
